/**
 * @author      sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { Listable } from '@zcode/state-type'
import type { getListCardAmenities } from './helpers/getListCardAmenities'

export interface ListingCardAmenitiesProps {
  amenitiesList:
    | Readonly<ReturnType<typeof getListCardAmenities>['amenitiesList']>
    | Listable['combinedAmenityTags']
  isSpotlight?: true
}

export const ListingCardAmenities = ({ amenitiesList, isSpotlight }: ListingCardAmenitiesProps) => {
  if (!amenitiesList.length) {
    return null
  }

  const amenitiesText = isSpotlight
    ? amenitiesList
    : amenitiesList.slice(0, 6).sort((a, b) => a.localeCompare(b))

  return (
    <div className="flex flex-col gap-1 text-sm">
      <div className={`font-bold ${isSpotlight ? 'text-gray-0' : 'text-gray-950'}`}>
        Top amenities
      </div>
      <div className="max-h-[90px] gap-y-1 gap-x-2 flex flex-col flex-wrap">
        {amenitiesText.map((amenity) => (
          <div
            className={`${isSpotlight ? 'text-neutral-200' : 'text-gray-600'} overflow-hidden text-ellipsis whitespace-nowrap max-w-[50%]`}
            key={amenity}
          >
            {amenity}
          </div>
        ))}
      </div>
    </div>
  )
}
